import { currencyCode } from './currency';

export function displayBalance(amount, hidden, currency) {
  const code = currencyCode(currency);
  if (hidden) return `••••••\u00a0${code}`;
  const value = Math.round((Number(amount) || 0) * 100) / 100;
  const formatted = Number.isInteger(value) ? String(value) : value.toFixed(2);
  return `${formatted}\u00a0${code}`;
}


export function formatBalanceParts(amount, hidden, currency) {
  const code = currencyCode(currency);
  if (hidden) {
    return { amount: '••••••', sign: code, full: `•••••• ${code}` };
  }
  const value = Math.round((Number(amount) || 0) * 100) / 100;
  const formatted = Number.isInteger(value)
    ? String(value)
    : value.toFixed(2).replace('.', ',');
  return {
    amount: formatted,
    sign: code,
    full: `${formatted} ${code}`,
  };
}
